import React from 'react';
import { Button } from '@/components/atoms/PcButton';
import { InputBox } from '@/components/atoms/InputBox';

const TestPage = () => {
  return (
    <div className="flex  w-full flex-col gap-8  bg-white p-[60px]">
      <div className="flex w-[300px] flex-col gap-4">
        <Button variant={'solid'} size="medium">
          Default Medium Button
        </Button>
        <Button variant="solid" size="medium" disabled>
          Default Medium Button disabled
        </Button>

        <Button variant="secondary" size="medium">
          Secondary Button
        </Button>
        <Button variant="secondary" size="medium" disabled>
          Secondary Button
        </Button>

        <Button variant="solid" size="small">
          Default Medium Button
        </Button>
        <Button variant="solid" size="small" disabled>
          Default Medium Button disabled
        </Button>

        <Button variant="line" size="small">
          Default Medium Button
        </Button>
        <Button variant="line" size="small" disabled>
          Default Medium Button disabled
        </Button>
        <InputBox size="small" disabled placeholder="Search..." deleteBtn leftIcon={false} />

        <InputBox size="small" placeholder="Search..." leftIcon={false} />
        <InputBox size="small" placeholder="Search..." leftIcon={true} />
        <InputBox invalid placeholder="Search..." leftIcon={true} />
        <InputBox disabled placeholder="Search..." leftIcon={false} value={'disabled'} />
      </div>
    </div>
  );
};

export default TestPage;
